import './img.scss';
import { useMemo, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import useDebounce from '../../hooks/debounce';
import classNames from 'classnames';

// Static Assets
const image_no_image = '/assets/images/misc/no-image.svg'

const Img = ({ src: propSrc, bg, lazy, className, cover, ...props }) => {
	const [observerRef, inView] = useInView({
		threshold: 0,
		rootMargin: '5%',
		triggerOnce: true,
		disabled: !lazy,
	});

	// if(propSrc === false) {
	// 	console.trace('WOW', propSrc);
	// }

	const [loadStatus, setLoadStatus] = useState(lazy ? 0 : 1);

	const debouncedInView = useDebounce(inView, 100, inView);
	const loading = (loadStatus === 0 || (lazy && !debouncedInView));

	const reqSrc = useMemo(() => {
		return (!lazy || inView) ? (propSrc || image_no_image) : undefined;
	}, [inView, lazy, propSrc])

	const { dataSrc, src, isFallback, ...computedProps } = useMemo(() => {
		const computedSrc = loadStatus === 2 ? image_no_image : reqSrc;

		return {
			className: classNames('img', className, {
				'lazy': lazy,
				'is-fallback': computedSrc === image_no_image,
				'loading': loading,
				'not-loading': !loading,
				'cover': cover,
			}),
			src: computedSrc,
			dataSrc: lazy ? computedSrc : undefined,
		}
	}, [reqSrc, inView, lazy, loading, cover, loadStatus, className]);

	const imageOnLoad = () => {
		if(loadStatus === 0) {
			setLoadStatus(1);
		}
	}

	const imageOnError = () => {
		setLoadStatus(2);
	}

	if(!bg) {
		return (
			<img
				ref={observerRef}
				src={src}
				onLoad={imageOnLoad}
				onError={imageOnError}
				data-src={dataSrc}
				{...props}
				{...computedProps} />
		);
	}
	else {
		return false;
	}

}

Img.defaultProps = {
	alt: 'Görsel',
	lazy: true,
}

export default Img;